import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4003';

export default {
  resetPassword: async (
    updatedPassword: string,
    encodedToken: string
  ): Promise<void> => {
    await axios.put<{ password: string }>(
      `${API_URL}/users/update-password`,
      {
        password: updatedPassword,
      },
      {
        headers: {
          Authorization: `Bearer ${encodedToken}`,
          'Content-Type': 'application/json',
        },
      }
    );
  },
};
